<template>
  <svg :height="`${height}px`" :width="`${width}px`" :class="`fill-current  text-${color}`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.38672 2.50781H20.6133C21.0987 2.50781 21.4922 2.90131 21.4922 3.38672V8.32679C21.2173 8.22963 20.9215 8.17676 20.6133 8.17676H10.8135C9.35726 8.17676 8.17676 9.35726 8.17676 10.8135V20.6133C8.17676 20.9215 8.22963 21.2173 8.32679 21.4922H3.38672C2.90131 21.4922 2.50781 21.0987 2.50781 20.6133V3.38672C2.50781 2.90131 2.90131 2.50781 3.38672 2.50781ZM10.8135 21.4922H20.6133C21.0987 21.4922 21.4922 21.0987 21.4922 20.6133V10.8135C21.4922 10.3281 21.0987 9.93457 20.6133 9.93457H10.8135C10.3281 9.93457 9.93457 10.3281 9.93457 10.8135V20.6133C9.93457 21.0987 10.3281 21.4922 10.8135 21.4922ZM10.8135 23.25H3.38672C1.9305 23.25 0.75 22.0695 0.75 20.6133V3.38672C0.75 1.9305 1.9305 0.75 3.38672 0.75H20.6133C22.0695 0.75 23.25 1.9305 23.25 3.38672V10.8135V20.6133C23.25 22.0695 22.0695 23.25 20.6133 23.25H10.8135ZM8.17676 4.70508H15.5596V6.46289H8.17676V4.70508ZM18.5918 11.1211H12.8789V12.8789H18.5918V11.1211Z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#333'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
